import React from 'react';
import ReactDOM from 'react-dom';
// CONTAINERS
import App from './containers/App';
// STYLES
import './index.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);